/*@flow*/
import { SET_RECORD } from 'lib/constants';
import setIn from 'lib/setIn';
import type { PayloadT } from 'lib/setIn';
import type { Map } from 'immutable';

type OptionsT = { type: string, payload: PayloadT };

export default (state: Map<*, *>, { type, payload }: OptionsT) => {
  let newState = state;
  switch (type) {
    case SET_RECORD:
      if (typeof payload.path !== 'string') {
        throw new TypeError(
          `[reducers] Cannot handle this type of path: '${JSON.stringify(
            payload.path
          )}'`
        );
      }
      newState = setIn(state)(payload);
      break;
    default:
      break;
  }

  return newState;
};
